<template>

<div class="task" :class="{'is-completed': completed, 'is-viewed': viewed, 'is-new': isNew}" v-on:click="onClick">

	<div class="task-icon" v-if="!completed">

		<i class="fa fa-camera" v-if="task.type === $constants.task.photo"></i>
		<i class="fa fa-video" v-if="task.type === $constants.task.video"></i>
		<i class="fa fa-list-ol" v-if="task.type === $constants.task.multi"></i>
		<i class="fa fa-microphone" v-if="task.type === $constants.task.audio"></i>

	</div>

	<div class="task-icon" v-if="completed">

		<i class="fa fa-check"></i>

	</div>
	
	<div class="task-name">

		<div class="task-name-new" v-if="isNew">New</div>
		{{ task.name }}

	</div>

	<div class="task-bookmark" v-if="!completed || bookmarked">

		<i class="fa fa-star-o" v-if="!bookmarked" v-on:click.stop="onBookmarkClick"></i>
		<i class="fa fa-star" v-if="bookmarked" v-on:click.stop="onBookmarkClick"></i>

	</div>

	<div class="task-share" v-if="completed">

		<i class="fa fa-share-square" v-on:click.stop="onShareClick"></i>

	</div>

	<div class="task-points">

		+{{ points }}

	</div>

	<div class="share" v-if="is.sharing">

		<div class="share-item is-facebook" v-on:click.stop="onShareItem('fb')"><i class="fa fa-facebook"></i></div>
		<div class="share-item is-twitter" v-on:click.stop="onShareItem('tw')"><i class="fa fa-twitter"></i></div>
		<div class="share-item is-pinterest" v-on:click.stop="onShareItem('pi')"><i class="fa fa-pinterest"></i></div>
		<div class="share-item is-email" v-on:click.stop="onShareItem('em')"><i class="fa fa-envelope"></i></div>

	</div>

</div>

</template>

<script>

import Cookies from 'js-cookie'

export default {

	props: ['task', 'source'],

	data: function() {
	
		return {
			is: {
				sharing: false
			}
		}

	},

	created: function() {

		window.addEventListener('click', this.onCloseSharing.bind(this))

	},

	beforeDestroy: function() {

		window.removeEventListener('click', this.onCloseSharing.bind(this))

	},

	computed: {

		viewed: function() {

			var viewed = JSON.parse(Cookies.get('viewed') || '[]')
		
			return this.$_.contains(viewed, this.task.id)

		},

		isNew: function() {

			var tasks = JSON.parse(Cookies.get('tasks') || '[]')
		
			return !this.$_.contains(tasks, this.task.id)

		},

		points: function() {

			if (this.saved) {

				var saved = this.$store.getters['session/tasks'][this.task.id]

				if (this.task.type === this.$constants.task.multi && saved.status === this.$constants.task.incomplete) {

					return Math.floor(saved.points / 2)

				} else {

					return saved.points

				}

			} else {

				return this.task.points

			}

		},

		completed: function() {

			return this.$_.contains(this.$store.getters['session/tasks/completed'], this.task.id)

		},

		saved: function() {

			return this.$_.contains(this.$_.keys(this.$store.getters['session/tasks']), this.task.id)

		},

		bookmarked: function() {

			return this.$_.contains(this.$store.getters['session/bookmarked'], this.task.id)

		}

	},

	methods: {

		onClick: function() {

			this.$router.push({
				name: 'Task',
				query: {
					task: this.task.id,
					from: (this.source) ? this.source : 'Tasks'
				}
			})

		},

		onBookmarkClick: function() {

			this.$api.request('bookmark', {
				task: this.task.id
			}).then(function(response) {

				this.$store.commit('session', response.session)

			}.bind(this))

		},

		onShareClick: function() {

			if (navigator.share) {

				navigator.share({
					title: 'Greenstar',
					text: this.task.name,
					url: this.$store.getters['session/tasks'][this.task.id].asset
				})

			} else {

				this.is.sharing = true

			}

		},

		onShareItem: function(type) {

			var text = this.task.name
			var url = this.$store.getters['session/tasks'][this.task.id].asset

			if (type === 'tw') {

				window.open("https://twitter.com/share?url="+ encodeURIComponent(url)+"&text="+encodeURIComponent(text), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')

			} else if (type === 'fb') {

				window.open('http://facebook.com/sharer/sharer.php?u='+encodeURIComponent(url), '', 'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0')

			} else if (type === 'pi') {

				window.open('https://pinterest.com/pin/create/button/?url='+encodeURIComponent(url)+'&media='+encodeURIComponent(url)+'&description='+encodeURIComponent(text), '', 'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0')

			} else if (type === 'em') {

				window.open('mailto:?subject=Greenstar&body='+encodeURIComponent(text)+' '+encodeURIComponent(url), '', 'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0')

			}

		},

		onCloseSharing: function() {

			this.is.sharing = false

		}

	}

}

</script>

<style scoped>

.task {
	width: 100%;
	display: flex;
	flex-direction: row;
	margin-bottom: 16px;
    padding-bottom: 16px;
	border-bottom: 1px solid #efefef;
}

.task:last-child {
	margin-bottom: 0px;
	border-bottom: 0px;
}

.task-icon {
	flex-shrink: 0;
	width: 24px;
	line-height: 36px;
	color: #428103;
	font-size: 16px;
}

.task-name {
	flex-grow: 1;
	line-height: 20x;
	padding: 8px 10px;
	color: #212121;
	font-weight: bold;
	font-size: 16px;
}

.task.is-viewed:not(.is-completed) .task-name {
	font-weight: 300;
}

.task.is-completed .task-name {
	color: #c6d7c0;
}

.task-name-new {
	display: inline-block;
	background-color: #ed4646;
	color: #fff;
	border-radius: 4px;
	padding: 2px 4px;
	font-size: 14px;
	font-weight: 500;
	margin-right: 5px;
}

.task-share {
	flex-shrink: 0;
	width: 24px;
	line-height: 36px;
	text-align: right;
	color: #428103;
	font-size: 24px;
	cursor: pointer;
	margin-left: 20px;
	margin-right: 20px;
}

.task-points {
	flex-shrink: 0;
	width: 48px;
	height: 36px;
	line-height: 34px;
	text-align: center;
	border: 1px solid #428103;
	border-radius: 8px;
	color: #428103;
	font-size: 16px;
}

.task.is-completed .task-points {
	background-color: #428103;
	color: #fff;
	font-weight: bold;
}

.task-bookmark {
	flex-shrink: 0;
	width: 24px;
	line-height: 36px;
	text-align: right;
	color: #428103;
	font-size: 24px;
	cursor: pointer;
	margin-left: 20px;
	margin-right: 20px;
}

.share {
	position: fixed;
	bottom: 0px;
	left: 0px;
	width: 100%;
	z-index: 1000;
	height: 64px;
	display: flex;
	flex-direction: row;
	background-color: #fff;
}

.share-item {
	height: 64px;
	width: 25%;
	text-align: center;
	line-height: 64px;
	color: #fff;
	cursor: pointer;
	font-size: 32px;
}

.share-item.is-facebook {
	background-color: #4267B2;	
}

.share-item.is-twitter {
	background-color: #1DA1F2;
}

.share-item.is-pinterest {
	background-color: #E60023;
}

.share-item.is-email {
	background-color: #333;
}

</style>
